var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.14 887.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d86319;}.cls-2{fill:#e98546;}.cls-3{fill:#bc4e08;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.32,
    y: 621.01,
    width: 434.4,
    height: 47.23,
    rx: 23.61,
    transform: "translate(487.04 1289.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 238.57,
    cy: 238.57,
    r: 230.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.57,477.14c131.55,0,238.57-107,238.57-238.57S370.12,0,238.57,0,0,107,0,238.57,107,477.14,238.57,477.14Zm0-460.4c122.32,0,221.84,99.51,221.84,221.83S360.89,460.41,238.57,460.41,16.74,360.89,16.74,238.57,116.25,16.74,238.57,16.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 327.98,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.67,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237,285.58a136.36,136.36,0,0,1,93.38,36.84A8.63,8.63,0,0,1,318.59,335a119.49,119.49,0,0,0-163.2,0,8.64,8.64,0,0,1-11.79-12.62A136.38,136.38,0,0,1,237,285.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.27,856.58V885H196.15V862.48l39.29-36.34q5.13-4.82,6.83-8.23a14.86,14.86,0,0,0,1.71-6.68,7.73,7.73,0,0,0-2.72-6.29q-2.72-2.25-7.84-2.25a17.64,17.64,0,0,0-9.32,2.64,17.4,17.4,0,0,0-6.68,7.45L189.78,799A45.38,45.38,0,0,1,208,780.56q12-6.75,28.89-6.76a58.16,58.16,0,0,1,22.82,4.2,35.56,35.56,0,0,1,15.53,12,29.75,29.75,0,0,1,5.6,17.85A38,38,0,0,1,277,824.66q-3.81,7.85-14.83,17.79l-15.53,14.13Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood2);
export default __webpack_public_path__ + "static/media/mood-2.a9ee37e1.svg";
export { ForwardRef as ReactComponent };